import { useEffect, useState } from "react";
import LogoSupremacyBig from "../../assets/assets/elevva-mora_big.png";
import MobConfig from "./mob-config";
import MobMembership from "./mob-membership";
import MobBooking from "./mob-booking";
import MobBiometrics from "./mob-biometrics";
import MobAdministrative from "./mob-administrative";
import InlineModal from "../info-modal/infoModal";
import { instance } from "../../utils/utils";
import MobPlans from "./plans/mob-plans";
import TermsModal from "../terms-modal/termsModal";
import Topbar from "../top-bar/top-bar";

const Mob = () => {
  const [selectedTab, setSelectedTab] = useState(1);
  const accessRol = localStorage.elevva_role;
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);

  useEffect(() => {
    if (accessRol === "30") {
      setSelectedTab(3);

      const checkTermsAndRedirect = async () => {
        const termsAccepted =
          localStorage.terms_and_conditions_accepted === "true";
        const privacyAccepted = localStorage.privacy_policy_accepted === "true";
        const role = parseInt(localStorage.elevva_role);
        const validRole = [10, 20, 30].includes(role);
        try {
          const companyData = await instance
            .get("memberships/corp/company")
            .then((res) => res.data);

          if (companyData?.is_force_onboarding) {
            setShowOnboardingModal(true);

            if (!termsAccepted && !privacyAccepted && validRole) {
              setShowTermsModal(true);
              return;
            }
          } else if (!termsAccepted && !privacyAccepted && validRole) {
            setShowTermsModal(true);
            return;
          }
        } catch (err) {
          console.error(err);
        }
      };

      checkTermsAndRedirect();
    }
  }, [accessRol]);

  return (
    <>
      <div
        style={{
          flexGrow: "1",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          width: "100%",
          overflow: "auto",
        }}
      >
        <Topbar />
        <div
          style={{
            flexGrow: 1,
            ...(selectedTab === 1 ? { height: "calc(100% - 60px)" } : {}),
            backgroundColor: "white",
            borderTopLeftRadius: "10px",
            borderBottomLeftRadius: "10px"
          }}
          className="d-flex "
        >
          <div
            style={{
              width: "100%",

              borderRadius: "10px",
              height: "calc(100% - 1.5rem)",
              padding: "3rem 3rem 0rem 3rem",
              flexGrow: "1",
              overflow: "auto",
              columnGap: "calc(.5rem + .5vw)",
            }}
            className="d-flex m-3"
          >
            <div
              style={{
                width: "100%",
                border: "1px solid #B6C1CE",
                borderRadius: "10px",
                height: "calc(100% - 1.5rem)",
                flexGrow: "1",
                columnGap: "calc(.5rem + .5vw)",
                position: "relative",
              }}
              className="d-flex p-3 h-100"
            >
              <div
                style={{
                  top: "-42px",
                  position: "absolute",
                  zIndex: selectedTab == 1 ? "3" : selectedTab == 4 ? "0" : "2",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="tab"
                  onClick={() => (accessRol == 30 ? null : setSelectedTab(1))}
                >
                  <div
                    className="tab-label"
                    style={
                      selectedTab === 1
                        ? { borderBottom: "1px solid #ffff" }
                        : {
                          borderBottom: "1px solid #b0bac5",
                          background: accessRol == 30 ? "#9c9c9c" : "white",
                        }
                    }
                  >
                    Configuración
                  </div>
                </div>
              </div>
              <div
                style={{
                  top: "-42px",
                  left: "13rem",
                  position: "absolute",
                  zIndex: selectedTab == 2 ? "3" : selectedTab == 4 ? "1" : "2",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="tab"
                  onClick={() => (accessRol == 30 ? null : setSelectedTab(2))}
                >
                  <div
                    className="tab-label"
                    style={
                      selectedTab === 2
                        ? { borderBottom: "1px solid #ffff" }
                        : {
                          borderBottom: "1px solid #b0bac5",
                          background: accessRol == 30 ? "#9c9c9c" : "white",
                        }
                    }
                  >
                    Planes
                  </div>
                </div>
              </div>
              <div
                style={{
                  top: "-42px",
                  left: "23rem",
                  position: "absolute",
                  zIndex: selectedTab == 3 ? "3" : selectedTab == 4 ? "2" : "1",
                  borderRadius: "10px",
                }}
              >
                <div className="tab" onClick={() => setSelectedTab(3)}>
                  <div
                    className="tab-label"
                    style={
                      selectedTab === 3
                        ? { borderBottom: "1px solid #fff" }
                        : { borderBottom: "1px solid #b0bac5" }
                    }
                  >
                    Reservas
                  </div>
                </div>
              </div>
              <div
                style={{
                  top: "-42px",
                  left: "33rem",
                  position: "absolute",
                  zIndex: selectedTab == 4 ? "3" : selectedTab == 5 ? "0" : "2",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="tab"
                  onClick={() => (accessRol == 30 ? null : setSelectedTab(4))}
                >
                  <div
                    className="tab-label"
                    style={
                      selectedTab === 4
                        ? { borderBottom: "1px solid #fff" }
                        : {
                          borderBottom: "1px solid #b0bac5",
                          background: accessRol == 30 ? "#9c9c9c" : "white",
                        }
                    }
                  >
                    Administrativo
                  </div>
                </div>
              </div>
              <div
                style={{
                  top: "-42px",
                  left: "46rem",
                  position: "absolute",
                  zIndex: selectedTab == 5 ? "3" : "0",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="tab"
                  onClick={() => setSelectedTab(5)}
                >
                  <div
                    className="tab-label"
                    style={
                      selectedTab === 5
                        ? { borderBottom: "1px solid #fff" }
                        : { borderBottom: "1px solid #b0bac5" }
                    }
                  >
                    Biométricos
                  </div>
                </div>
              </div>
              {selectedTab === 1 && <MobConfig />}
              {selectedTab === 2 && <MobPlans />}
              {selectedTab === 3 && <MobBooking />}
              {selectedTab === 4 && <MobAdministrative />}
              {selectedTab === 5 && <MobBiometrics />}
            </div>
          </div>
        </div>
      </div>
      {showTermsModal && <TermsModal onClose={() => setShowTermsModal(false)} />}

      {showOnboardingModal && (
        <InlineModal
          title="Completa tu información"
          description="Hay algunos datos importantes que aún no has completado o actualizado. Esto es necesario para brindarte una mejor experiencia en la plataforma."
          primaryAction={{
            label: "Completar ahora",
            onClick: () => {
              setShowOnboardingModal(false);
              window.location.href = "selectMembership/Usuario?fromAdmin=true";
            },
          }}
        />
      )}
    </>
  );
};
export default Mob;
